import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentCancel() {
  return (
    <div className="bg-[#F4EFE7] min-h-screen flex items-center" data-testid="payment-cancel-page">
      <section className="max-w-[700px] mx-auto px-6 sm:px-8">
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1E1B18] mb-4">Checkout cancelled</h1>
        <p className="text-[15px] text-[#1E1B18]/65 mb-8">No payment was taken. Your gift card wasn't purchased.</p>
        <Link to="/gift-cards" data-testid="payment-cancel-back" className="bg-[#0F0E0C] text-[#F4EFE7] px-6 py-3 rounded-full text-[13px] font-medium">Back to gift cards</Link>
      </section>
    </div>
  );
}
